export default "__VITE_ASSET__y23rOOwD__"